import { render } from "./TerminosDeUso.vue?vue&type=template&id=3ebade0e&scoped=true"
import script from "./TerminosDeUso.vue?vue&type=script&lang=js"
export * from "./TerminosDeUso.vue?vue&type=script&lang=js"

import "./TerminosDeUso.vue?vue&type=style&index=0&id=3ebade0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebade0e"]])

export default __exports__